import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { BusinessPortalList } from './../models/businessPortalList';
import { BusinessPortalService } from './business-portal.services';

@Injectable()
export class BusinessPortalListResolver {

  constructor(private backend: BusinessPortalService) { }

  resolve(): Observable<BusinessPortalList[]> {
    return this.backend.getAll();
  }
}


@Injectable()
export class BusinessPortalEditResolver {

  constructor(private backend: BusinessPortalService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getById(+route.params['pid']);
  }
}

@Injectable()
export class PortalManagerUserlistResolver {
  constructor(private backend: BusinessPortalService) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getPortalUsersByPortalManagerId(+route.parent!.params['pid']);
  }
}

@Injectable()
export class PortalBusListResolver{
  constructor(private backend: BusinessPortalService) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getPortalbusList(+route.parent!.params['pid']);
  }
}

